import { memo } from 'react';
import type { CardProps } from '@/src/types';
import { cn } from '@/src/utils';

function Card({ children, className, hover = true, glow = false }: CardProps) {
  return (
    <div
      className={cn(
        'relative rounded-2xl bg-[#0a0a0a] border border-white/10 overflow-hidden',
        hover && 'transition-all duration-300 hover:border-white/20 hover:-translate-y-1',
        glow && 'shadow-[0_0_30px_rgba(59,130,246,0.15)]',
        'group',
        className
      )}
    >
      {/* Hover glow effect */}
      {hover && (
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
      )}

      {/* Content */}
      <div className="relative z-10">{children}</div>

      {/* Bottom highlight line */}
      {hover && (
        <div className="absolute bottom-0 left-0 w-0 h-[2px] bg-gradient-to-r from-blue-500 to-purple-500 group-hover:w-full transition-all duration-500 ease-out" />
      )}
    </div>
  );
}

export default memo(Card);
